<template>
    <div class="amap-container">
        <!-- 地图容器 -->
        <div id="amap" class="map-wrapper"></div>

        <!-- 控制面板 -->
        <!-- <div class="map-control">
            <button @click="addMarker" class="control-btn primary">添加标记</button>
            <button @click="clearMarkers" class="control-btn secondary">清除标记</button>
            <button @click="toggleTraffic" class="control-btn tertiary">
                {{ showTraffic ? '关闭交通' : '显示交通' }}
            </button>
            <button @click="setDefaultLocation" class="control-btn default">
                恢复默认地点
            </button>
        </div> -->

        <!-- 位置信息展示 -->
        <!-- <div class="location-info" v-if="currentLocation">
            <h3>当前位置</h3>
            <p>经度: {{ currentLocation.lng }}</p>
            <p>纬度: {{ currentLocation.lat }}</p>
            <p>地址: {{ currentAddress }}</p>
        </div> -->
    </div>
</template>

<script>
export default {
    name: 'Amap',
    data() {
        return {
            map: null,          // 地图实例
            markers: [],        // 标记点数组
            infoWindow: null,   // 信息窗口实例
            geocoder: null,     // 地理编码实例
            showTraffic: false, // 是否显示交通状况
            currentLocation: null, // 当前位置经纬度
            currentAddress: '',  // 当前位置地址
            // 默认地点设置 - 可以根据需要修改
            defaultLocation: {
                lng: 120.063938,
                lat: 30.32492,
                name: '浙江省杭州市西湖区西园六路苏家坝21号福华大厦B301'
            }
        }
    },
    mounted() {
        // 初始化地图
        setTimeout(() => {
            this.initMap();
        }, 600)

        // 监听窗口大小变化，调整地图尺寸
        // window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        // 移除事件监听
        window.removeEventListener('resize', this.handleResize);

        // 销毁地图实例
        if (this.map) {
            this.map.destroy();
        }
    },
    methods: {
        // 初始化地图
        initMap() {
            // 检查高德地图API是否加载完成
            if (!window.AMap) {
                console.error('高德地图API加载失败');
                return;
            }

            // 创建地图实例，使用默认地点作为中心点
            this.map = new window.AMap.Map('amap', {
                zoom: 50,
                center: [this.defaultLocation.lng, this.defaultLocation.lat],
                resizeEnable: true,
                mapStyle: 'amap://styles/normal'
            });

            // 添加地图控件
            // this.map.addControl(new window.AMap.ToolBar({
            //     position: 'RB'  // 右下角
            // }));

            this.map.addControl(new window.AMap.Scale());

            // 创建信息窗口
            this.infoWindow = new window.AMap.InfoWindow({
                offset: new window.AMap.Pixel(0, -30)
            });

            // 创建地理编码实例
            this.geocoder = new window.AMap.Geocoder({
                city: '全国'  // 默认城市
            });

            // 绑定地图点击事件
            this.map.on('click', this.handleMapClick);

            // 设置默认地点并添加标记
            this.setDefaultLocation(true);

            // 获取当前位置（可选：如果获取失败将保留默认地点）
            // this.getCurrentLocation();
        },

        // 设置默认地点
        setDefaultLocation(init = false) {
            // 如果不是初始化，先清除现有标记
            if (!init) {
                this.clearMarkers();
            }

            // 设置当前位置为默认地点
            this.currentLocation = {
                lng: this.defaultLocation.lng,
                lat: this.defaultLocation.lat
            };

            // 获取默认地点的地址信息
            this.geocoder.getAddress(
                [this.defaultLocation.lng, this.defaultLocation.lat],
                (status, result) => {
                    if (status === 'complete' && result.regeocode) {
                        this.currentAddress = result.regeocode.formattedAddress;
                    } else {
                        this.currentAddress = this.defaultLocation.name;
                    }

                    // 添加默认标记
                    this.addMarker();
                }
            );

            // 移动地图到默认地点
            this.map.setCenter([this.defaultLocation.lng, this.defaultLocation.lat]);
        },

        // 处理地图点击事件
        handleMapClick(e) {
            const { lng, lat } = e.lnglat;
            this.currentLocation = { lng, lat };
            console.log(lng, lat);


            // 逆地理编码获取地址信息
            this.geocoder.getAddress([lng, lat], (status, result) => {
                if (status === 'complete' && result.regeocode) {
                    this.currentAddress = result.regeocode.formattedAddress;
                } else {
                    this.currentAddress = '获取地址失败';
                }
            });
        },

        // 添加标记点
        addMarker() {
            if (!this.currentLocation) return;

            const { lng, lat } = this.currentLocation;

            // 创建标记点
            const marker = new window.AMap.Marker({
                position: [lng, lat],
                title: this.currentAddress || '标记点',
                icon: new window.AMap.Icon({
                    size: new window.AMap.Size(20, 20),
                    image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                    imageSize: new window.AMap.Size(20, 20)
                }),
                anchor: 'bottom-center'
            });

            // 添加到地图
            marker.setMap(this.map);
            this.markers.push(marker);

            // 绑定标记点点击事件
            marker.on('click', () => {
                this.infoWindow.setContent(`
          <div style="padding: 10px;">
            <h3 style="margin: 0 0 5px;">${marker.getTitle()}</h3>
            <p style="margin: 0; font-size: 12px;">经度: ${lng.toFixed(6)}</p>
            <p style="margin: 0; font-size: 12px;">纬度: ${lat.toFixed(6)}</p>
          </div>
        `);
                this.infoWindow.open(this.map, marker.getPosition());
            });

            // 移动地图到标记点
            this.map.setCenter([lng, lat]);
        },

        // 清除所有标记点
        clearMarkers() {
            this.markers.forEach(marker => {
                marker.remove();
            });
            this.markers = [];
            this.infoWindow.close();
        },

        // 切换交通状况显示
        toggleTraffic() {
            this.showTraffic = !this.showTraffic;

            if (this.showTraffic) {
                // 添加交通图层
                this.map.add(new window.AMap.Traffic());
            } else {
                // 移除所有交通图层
                this.map.removeLayer(window.AMap.Traffic);
            }
        },

        // 获取当前位置
        getCurrentLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { longitude: lng, latitude: lat } = position.coords;
                        this.currentLocation = { lng, lat };
                        this.map.setCenter([lng, lat]);

                        // 获取地址信息
                        this.geocoder.getAddress([lng, lat], (status, result) => {
                            if (status === 'complete' && result.regeocode) {
                                this.currentAddress = result.regeocode.formattedAddress;
                            }
                        });
                    },
                    (error) => {
                        console.error('获取位置失败:', error);
                        // 失败时保持默认地点
                        alert('无法获取您的位置，将使用默认地点');
                    }
                );
            } else {
                alert('您的浏览器不支持地理位置定位，将使用默认地点');
            }
        },

        // 处理窗口大小变化
        handleResize() {
            if (this.map) {
                this.map.resize();
            }
        }
    }
}
</script>

<style scoped>
.amap-container {
    position: relative;
    width: 100%;
    height: 100%;
}

.map-wrapper {
    width: 100%;
    height: 100%;
}

.map-control {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 10;
    display: flex;
    gap: 10px;
    padding: 10px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    flex-wrap: wrap;
}

.control-btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
}

.control-btn.primary {
    background-color: #1677ff;
    color: white;
}

.control-btn.secondary {
    background-color: #f5f5f5;
    color: #333;
}

.control-btn.tertiary {
    background-color: #fff;
    color: #1677ff;
    border: 1px solid #1677ff;
}

.control-btn.default {
    background-color: #52c41a;
    color: white;
}

.control-btn:hover {
    opacity: 0.9;
    transform: translateY(-1px);
}

.location-info {
    position: absolute;
    bottom: 20px;
    left: 20px;
    z-index: 10;
    padding: 15px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    max-width: 300px;
}

.location-info h3 {
    margin: 0 0 10px;
    font-size: 16px;
    color: #333;
}

.location-info p {
    margin: 5px 0;
    font-size: 14px;
    color: #666;
}
</style>